module.exports = __webpack_public_path__ + "static/media/xudinglaodonghetong1.e108a40f.png";